import { Header, Footer } from '@/components/layout'
import { SEO } from '@/components/seo'

export default function FeaturesPage() {
  return (
    <div className="min-h-screen bg-surface-950">
      <SEO
        title="Features"
        description="Explore all JumpstoneAuth features: passwordless authentication, MFA, SSO, user management, multi-tenant support, and more."
        canonical="/features"
      />
      <Header />
      <main className="pt-24 pb-16">
        <div className="mx-auto max-w-7xl section-padding">
          <h1 className="text-4xl font-bold text-white mb-4">Features</h1>
          <p className="text-lg text-surface-400">Everything you need for authentication</p>
        </div>
      </main>
      <Footer />
    </div>
  )
}

